import { defineStyleConfig } from '@chakra-ui/react';

import { flushedFocusVisible, outlineFocusVisible } from './focus-styles';

export const Textarea = defineStyleConfig({
	variants: {
		outline: outlineFocusVisible,
		filled: outlineFocusVisible,
		flushed: flushedFocusVisible,
	},
});
